import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '../consts'
import { mapFiles } from './upload'

export const mapBankAccount = (data = {}, params) => ({
  ...data,
  bankId: data?.bank?.id,
  accountDigit: data?.digit,
  accountType: data?.accountType?.id,
  files: mapFiles(data?.documentFiles || [], params)
})

export const mapBankAccountInput = ({ entityId, schema, data } = {}) => ({
  ...camelToSnakeKeys({
    bankId: data.bankId ? +data.bankId : '',
    agency: data?.agency,
    account: data?.account,
    digit: data?.accountDigit,
    accountTypeId: data?.accountType,
    modality: data?.modality,
    pix: data?.pix,
  }),
  custom_fields: mapCustomFieldValues({
    data,
    schema,
    entityId,
    sectionId: PERSONAL_AREA.BANK_ACCOUNTS,
  })
})
